import { STATES } from '@shared/common';
import { COUNTRY_CODE } from '@shared/common';
import { Environment } from '@shared/environment';
export const environment: Environment = {
	iosLink: 'https://itunes.apple.com/app/1453830595',
	androidLink: 'https://play.google.com/store/apps/details?id=com.restoreunited',
	platform: 'web',
	production: true,
	domain: 'rudevops.com',
	company: 'RestoreUnited',
	companyCode: 'btr',
	env: {
		apiUrl: 'https://saas.restoreunited.com:81', // We are using production API for Rudevops as we only intend to use it with companyCode 'btr'
		baseUrl: 'https://rudevops.com',
		chatSignalr: 'https://apistage.restoreunited.com:8080',

		testApiUrl: 'https://apitest.restoreunited.com',
		testChatSignalr: 'https://apitest.restoreunited.com:8080',

		googleToken: ['67273863217-mh1v5sd00kuga72dt4g9etlvvrt0trfp', 'apps.googleusercontent.com'].join('.'),
	},
	firebase: {
		apiKey: 'AIzaSyBhTl5D6W-BAyCWqAzQ3Zy5JwjxpsW_Kuw',
		authDomain: 'restoreunited.firebaseapp.com',
		databaseURL: 'https://restoreunited.firebaseio.com',
		projectId: 'restoreunited',
		storageBucket: 'restoreunited.appspot.com',
		messagingSenderId: '67273863217',
	},
	facebook: {
		appId: '328628611172065',
		cookie: true,
		xfbml: true,
		version: 'v3.2',
	},
	states: STATES,
	countryCode: COUNTRY_CODE,
	region: 'US',
	googleAPIKey: 'AIzaSyCdzfRmfJI15T6d_mUstRJjZDPhCxyQAU4',
};
